import { render, staticRenderFns } from "./ChooseOrganization.vue?vue&type=template&id=693893da&scoped=true&lang=pug&"
import script from "./ChooseOrganization.vue?vue&type=script&lang=js&"
export * from "./ChooseOrganization.vue?vue&type=script&lang=js&"
import style0 from "./ChooseOrganization.vue?vue&type=style&index=0&id=693893da&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693893da",
  null
  
)

export default component.exports